import React from 'react';
import {RouteComponentProps} from 'react-router-dom';
import {MatchParams} from '../../model/CustomModel';
import * as queryString from 'querystring';

const Company =
    ({match, location}: RouteComponentProps<MatchParams>) => {
        console.log('location search=', location.search);
        console.log('location pathname=', location.pathname);
        const query = queryString.parse(location.search);
        console.log('query print =1 ', query);
        return (
            <div className="bloc l-bloc" id="bloc-0">
                <h2>Company {match.params.id}</h2>
                <h4>detai=2: {query.detail}</h4>
            </div>
        );
    };

export default Company;
